import React, { useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Estilos rápidos para el dropzone y las cards
const dropzoneStyle = {
    border: '2px dashed #009ee3',
    borderRadius: '15px',
    padding: '40px',
    textAlign: 'center',
    cursor: 'pointer',
    backgroundColor: '#f8f9fa',
    transition: 'all 0.3s ease'
};

export default function AdministradorOfertas() {
    // Datos Dummy para que veas la interfaz funcionando
    const [ofertas, setOfertas] = useState([
        { id: 1, url: 'https://via.placeholder.com/400x200?text=Promo+Pizza+2x1', nombre: 'Pizza 2x1', activo: true },
        { id: 2, url: 'https://via.placeholder.com/400x200?text=Happy+Hour+Copete', nombre: 'Happy Hour', activo: false },
        { id: 3, url: 'https://via.placeholder.com/400x200?text=Postre+Gratis', nombre: 'Postre Gratis', activo: true },
    ]);

    const [loading, setLoading] = useState(false);

    // Función dummy para simular subida de archivo
    const handleFileUpload = (e) => {
        setLoading(true);
        // Aquí iría el axios.post con FormData
        setTimeout(() => {
            const nuevaOferta = {
                id: Date.now(),
                url: 'https://via.placeholder.com/400x200?text=Nueva+Oferta+Subida',
                nombre: 'Nueva Promo',
                activo: true
            };
            setOfertas([nuevaOferta, ...ofertas]);
            setLoading(false);
            toast.success("Imagen subida con éxito");
        }, 1500);
    };

    const toggleOferta = (id) => {
        setOfertas(ofertas.map(o => o.id === id ? { ...o, activo: !o.activo } : o));
        toast.info("Estado de oferta actualizado");
    };

    const eliminarOferta = (id) => {
        if (window.confirm("¿Estás seguro de eliminar esta oferta?")) {
            setOfertas(ofertas.filter(o => o.id !== id));
            toast.warn("Oferta eliminada");
        }
    };

    const abrirSegundaPantalla = () => {
        // Esto abre la ruta del display en una ventana nueva
        window.open('/display-ofertas', 'KomityDisplay', 'width=1280,height=720');
    };

    return (
        <div className="container-fluid p-4" style={{ backgroundColor: '#f4f7f6', minHeight: '100vh' }}>
            <ToastContainer position="top-right" autoClose={2000} />
            
            <div className="d-flex justify-content-between align-items-center mb-4">
                <div>
                    <h2 className="fw-bold text-dark">Mantenedor de Ofertas</h2>
                    <p className="text-muted">Gestiona las imágenes que se ven en el monitor de clientes</p>
                </div>
                <button className="btn btn-primary btn-lg shadow-sm" onClick={abrirSegundaPantalla} style={{ borderRadius: '12px' }}>
                    <i className="bi bi-display me-2"></i> Lanzar Segunda Pantalla
                </button>
            </div>

            <div className="row">
                {/* COLUMNA IZQUIERDA: SUBIDA */}
                <div className="col-md-4">
                    <div className="card border-0 shadow-sm p-4" style={{ borderRadius: '20px' }}>
                        <h5 className="mb-3 fw-bold">Subir Nueva Imagen</h5>
                        <div 
                            style={dropzoneStyle} 
                            onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#eef7ff'}
                            onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                            onClick={() => document.getElementById('fileInput').click()}
                        >
                            {loading ? (
                                <div className="spinner-border text-primary" role="status"></div>
                            ) : (
                                <>
                                    <i className="bi bi-cloud-arrow-up-fill display-4 text-primary"></i>
                                    <p className="mt-2 mb-0">Haz click o arrastra una imagen</p>
                                    <small className="text-muted">Recomendado: 1920x1080px</small>
                                </>
                            )}
                            <input 
                                type="file" 
                                id="fileInput" 
                                hidden 
                                onChange={handleFileUpload} 
                                accept="image/*" 
                            />
                        </div>
                        <div className="mt-4 p-3 bg-light rounded" style={{ fontSize: '0.85rem' }}>
                            <i className="bi bi-info-circle me-2 text-primary"></i>
                            Las imágenes subidas aparecerán automáticamente en el carrusel del monitor secundario.
                        </div>
                    </div>
                </div>

                {/* COLUMNA DERECHA: LISTADO */}
                <div className="col-md-8">
                    <div className="row">
                        {ofertas.map((oferta) => (
                            <div className="col-lg-6 mb-4" key={oferta.id}>
                                <div className="card border-0 shadow-sm h-100" style={{ borderRadius: '20px', overflow: 'hidden' }}>
                                    <div style={{ position: 'relative' }}>
                                        <img 
                                            src={oferta.url} 
                                            className="card-img-top" 
                                            alt={oferta.nombre} 
                                            style={{ height: '180px', objectFit: 'cover' }}
                                        />
                                        <div style={{
                                            position: 'absolute', top: '10px', right: '10px'
                                        }}>
                                            <span className={`badge ${oferta.activo ? 'bg-success' : 'bg-secondary'} shadow`}>
                                                {oferta.activo ? 'Activa' : 'Pausada'}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="card-body d-flex justify-content-between align-items-center">
                                        <h6 className="m-0 fw-bold">{oferta.nombre}</h6>
                                        <div className="btn-group">
                                            <button 
                                                className={`btn btn-sm ${oferta.activo ? 'btn-outline-warning' : 'btn-outline-success'}`}
                                                onClick={() => toggleOferta(oferta.id)}
                                                title={oferta.activo ? 'Pausar' : 'Activar'}
                                            >
                                                <i className={`bi ${oferta.activo ? 'bi-pause-fill' : 'bi-play-fill'}`}></i>
                                            </button>
                                            <button 
                                                className="btn btn-sm btn-outline-danger"
                                                onClick={() => eliminarOferta(oferta.id)}
                                                title="Eliminar"
                                            >
                                                <i className="bi bi-trash-fill"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}